import { CSSProperties, ReactNode } from "react";
import { Table } from "antd";
import type { TableProps } from "antd";

export type UITableProps<T extends object = Record<string, unknown>> =
  TableProps<T> & {
    sx?: Record<string, unknown>;
  };

export type UITableColumnsType<T extends object = Record<string, unknown>> =
  NonNullable<TableProps<T>["columns"]>;

export const UITable = <T extends object = Record<string, unknown>>({
  sx,
  style,
  ...props
}: UITableProps<T>) => <Table<T> style={{ ...(sx as CSSProperties), ...style }} {...props} />;

type LegacyContainerProps = {
  children?: ReactNode;
};

type LegacyCellProps = {
  children?: ReactNode;
  onClick?: () => void;
  sx?: Record<string, unknown>;
};

export const UITableContainer = ({ children }: LegacyContainerProps) => (
  <div>{children}</div>
);
export const UITableHead = ({ children }: LegacyContainerProps) => (
  <thead>{children}</thead>
);
export const UITableBody = ({ children }: LegacyContainerProps) => (
  <tbody>{children}</tbody>
);
export const UITableRow = ({ children }: LegacyContainerProps) => (
  <tr>{children}</tr>
);
export const UITableCell = ({ children, onClick, sx }: LegacyCellProps) => (
  <td style={sx as CSSProperties} onClick={onClick}>
    {children}
  </td>
);
